import { Box, Text } from '@chakra-ui/react';

type FooterProps<T extends object> = {
  selectedItems?: Record<string, T>;
  rows?: T[];
  loading?: boolean;
  total?: number;
  show?: boolean;
};

const Footer = <T extends object>({
  selectedItems = {},
  rows = [],
  loading = false,
  total,
  show = false,
}: FooterProps<T>) => {
  if (!rows || loading || !show) return null;

  return (
    <Box
      sx={{
        py: 4,
        px: 5,
        borderLeft: '1px solid #e4e3e2',
        borderRight: '1px solid #e4e3e2',
        borderBottom: '1px solid #e4e3e2',
        bgColor: 'white',
      }}
    >
      <Text
        sx={{
          fontSize: '11px',
          letterSpacing: 'wide',
          margin: 0,
          color: 'base2FontColour.500',
          fontWeight: 'medium',
        }}
      >
        {Object.keys(selectedItems).length} Selected / {total ?? rows.length} Total
      </Text>
    </Box>
  );
};

export default Footer;
